import { render } from "./FormativeAction.vue?vue&type=template&id=7cd96d4a"
import script from "./FormativeAction.vue?vue&type=script&lang=js"
export * from "./FormativeAction.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Usuario\\Documents\\frontCode\\GN-Students\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__